import { render, staticRenderFns } from "./MessageAuthenFormModal.vue?vue&type=template&id=6c4516da"
import script from "./MessageAuthenFormModal.vue?vue&type=script&lang=js"
export * from "./MessageAuthenFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports